import * as BABYLON from "@babylonjs/core";
import mergeConfig from "../tools/mergeConfig";

export default class BaseObject
{
    constructor(scene, name, options)
    {
        this.scene = scene;
        this.name = name;
        this.options = options;
        this.defaultState = Object.assign({}, options);
        this.currentState = {};

        this.node = false;
        this.visible = options.visible;
    }

    setState(newState)
    {
        newState = this.initNewState(newState);
        newState = this.mergeNewState(newState);
        this.runStateFunctions(newState);
    }

    initNewState(newState)
    {

        if (typeof newState === 'undefined')
        {
            newState = {};
        }

        if (typeof newState === 'boolean')
        {
            newState = {
                visible: newState
            }
        }

        return newState;
    }

    mergeNewState(newState)
    {
        return mergeConfig(this.defaultState, newState);
    }

    runStateFunctions(newState)
    {
        // visible: Objekt anzeigen / verstecken
        if (this.currentState.visible !== newState.visible)
        {
            this.setVisible(newState.visible);
        }

        // Größe / Scale
        if (this.currentState.scale !== newState.scale)
        {
            this.setScale(newState.scale);
        }

        if (this.currentState.scaling !== newState.scaling)
        {
            this.setScaling(new BABYLON.Vector3(...newState.scaling));
        }

        // Position
        if (this.currentState.position !== newState.position)
        {
            this.setPosition(new BABYLON.Vector3(...newState.position));
        }

        // Rotation
        if (this.currentState.rotation !== newState.rotation)
        {
            this.setRotation(new BABYLON.Vector3(...newState.rotation));
        }

        // setVisibility
        if (this.currentState.visibility !== newState.visibility)
        {
            this.setVisibility(newState.visibility);
        }

        // Diffuse
        if (this.currentState.diffuse !== newState.diffuse)
        {
            this.setDiffuse(...newState.diffuse);
        }

        // rotationQuaternion, siehe https://doc.babylonjs.com/features/position,_rotation,_scaling#rotationquaternion
        if (this.currentState.rotationQuaternion !== newState.rotationQuaternion)
        {
            this.setRotationQuaternion(new BABYLON.Vector4(...newState.rotationQuaternion));
        }

        this.currentState = newState;
    }

    show()
    {
        this.visible = true;

        if (this.node)
        {
            this.node.setEnabled(true);
        }
    }

    hide()
    {
        this.visible = false;

        if (this.node)
        {
            this.node.setEnabled(false);
        }
    }

    /**
     * Objekt anzeigen oder ausblenden.
     *
     * @param {boolean} value
     */
    setVisible(value)
    {
        if (value)
        {
            this.show();
        }
        else
        {
            this.hide();
        }
    }

    /**
     * Objekt Größe ändern (Alle Achsen auf einmal)
     *
     * @param {number} f
     */
    setScale(f)
    {
        if (this.node)
        {
            this.node.scaling = new BABYLON.Vector3(f, f, f);
        }
    }

    /**
     * Objekt Größe ändern (Alle Achsen einzeln)
     *
     * @param {BABYLON.Vector3} scale
     */
    setScaling(scale)
    {
        if (this.node)
        {
            this.node.scaling = scale;
        }
    }

    /**
     * Objekt Position ändern.
     *
     * @param {BABYLON.Vector3} position
     */
    setPosition(position)
    {
        if (this.node)
        {
            this.node.position = position;
        }
    }

    /**
     * Objekt Rotation ändern.
     *
     * @param {BABYLON.Vector3} rotation
     */
    setRotation(rotation)
    {
        if (this.node)
        {
            this.node.rotation = rotation;
        }
    }

    /**
     * Objekt Rotation Quaternion ändern.
     *
     * @param {BABYLON.Vector4} rotationQuaternion
     */
    setRotationQuaternion(rotationQuaternion)
    {
        if (this.node)
        {
            this.node.rotationQuaternion = rotationQuaternion;
        }
    }

    setVisibility(value)
    {
        if (this.node)
        {
            this.node.visibility = value;
        }
    }

    setDiffuse(r, g, b)
    {
        if (this.node && this.node.material)
        {
            let material = this.node.material;
            material.albedoColor = new BABYLON.Color3(r, g, b);
            this.node.material = material;
        }
    }
}